//Belastungstabelle für Deckenstärken in Abhängigkeit von der Spannweite
//Einfeldträger / Mehrfeldträger
import {HBESectionWidth} from "../globals";
import {toFixedFloat} from "../utils/utils";

export const RoofElementType = {
    Single: 1, Multi: 2
};

//Einfeldträger
export const RoofThicknessSingle = [//maxSpan in Metern, thickness in mm
    {maxSpan: 3.60, thickness: 120, fireRating: "R90"},
    {maxSpan: 4.20, thickness: 120, fireRating: "R90"}, {maxSpan: 4.60, thickness: 120, fireRating: "R90"},
    {maxSpan: 5.00, thickness: 140, fireRating: "R90"}, {maxSpan: 5.20, thickness: 140, fireRating: "R90"},
    {maxSpan: 5.40, thickness: 140, fireRating: "R90"}, {maxSpan: 5.70, thickness: 160, fireRating: "R90"},
    {maxSpan: 5.90, thickness: 160, fireRating: "R90"}, {maxSpan: 6.20, thickness: 160, fireRating: "R90"},
    {maxSpan: 6.50, thickness: 180, fireRating: "R90"}, {maxSpan: 6.70, thickness: 180, fireRating: "R90"},
    {maxSpan: 7.00, thickness: 180, fireRating: "R90"}, {maxSpan: 7.20, thickness: 200, fireRating: "R90"},
    {maxSpan: 7.60, thickness: 200, fireRating: "R90"}];

//Mehrfeldträger
export const RoofThicknessMulti = [//maxSpan in Metern, thickness in mm
    {maxSpan: 4.20, thickness: 100, fireRating: "R60"}, 
    {maxSpan: 4.60, thickness: 100, fireRating: "R60"},
    {maxSpan: 5.00, thickness: 100, fireRating: "R60"}, 
    {maxSpan: 5.20, thickness: 120, fireRating: "R90"},
    {maxSpan: 5.40, thickness: 120, fireRating: "R90"}, 
    {maxSpan: 5.70, thickness: 120, fireRating: "R90"},
    {maxSpan: 5.90, thickness: 120, fireRating: "R90"}, 
    {maxSpan: 6.20, thickness: 140, fireRating: "R90"},
    {maxSpan: 6.50, thickness: 140, fireRating: "R90"}, 
    {maxSpan: 6.70, thickness: 140, fireRating: "R90"},
    {maxSpan: 7.00, thickness: 160, fireRating: "R90"}, 
    {maxSpan: 7.20, thickness: 160, fireRating: "R90"},
    {maxSpan: 7.60, thickness: 160, fireRating: "R90"}];

export const maxAllowedRoofSpan = 7.60; //Maximale Spannweite, darüber hinaus muss ein Unterzug eingefügt werden.
export const maxAllowedRoofElementLength = 13.5; //Meter. Maximale Reallänge der Dachelemente. Bei größeren Längen muss geschnitten / mehrere Elemente zusammengesetzt werden auf Wand oder Unterzug

export const maxFreeOverhangWidth = 0.15; // m. #12742: Letztes Element darf maximal diese Breite haben wenn es frei hängend ist. Sollte das letzte Element breiter sein wird es halbiert und anteilig auf beide Seiten des Dachs platziert
export const maxRoofOverhang = toFixedFloat(0.5 * HBESectionWidth);
